import { Navigate } from 'react-router-dom'
import GuestLayout from '../layouts/GuestLayout'
import { routesGuest } from '../consts'
import { GuestAuthIntercept } from '../components/Guest/GuestAuthIntercept'
import {
  Main,
  Register,
  About,
  Rules,
  Privacy,
  Cookies,
  RestoreAccess,
} from '../pages'

export const guestRoutes = [
  {
    path: routesGuest.ROOT.path,
    element: <GuestLayout />,
    permissions: routesGuest.ROOT.permissions,
    children: [
      {
        path: routesGuest.ROOT.path,
        element: <Main />,
        permissions: routesGuest.ROOT.permissions,
      },
      {
        path: routesGuest.REGISTER.path,
        element: <Register />,
        permissions: routesGuest.ROOT.permissions,
      },
      {
        path: routesGuest.ABOUT.path,
        element: <About />,
        permissions: routesGuest.ROOT.permissions,
      },
      {
        path: routesGuest.RULES.path,
        element: <Rules />,
        permissions: routesGuest.ROOT.permissions,
      },
      {
        path: routesGuest.PRIVACY.path,
        element: <Privacy />,
        permissions: routesGuest.ROOT.permissions,
      },
      {
        path: routesGuest.COOKIES.path,
        element: <Cookies />,
        permissions: routesGuest.ROOT.permissions,
      },
      {
        path: routesGuest.TERMS.path,
        element: <Navigate to={`/${routesGuest.RULES.path}`} replace />,
        permissions: routesGuest.ROOT.permissions,
      },
      {
        path: routesGuest.USERAGREEMENT.path,
        element: <Navigate to={`/${routesGuest.RULES.path}`} replace />,
        permissions: routesGuest.ROOT.permissions,
      },
      {
        path: routesGuest.RESTOREACCESS.path,
        element: <RestoreAccess />,
        permissions: routesGuest.ROOT.permissions,
      },
      {
        path: `${routesGuest.ERROR.path}/:code`,
        element: (
          <div>
            <h1>Страница с ошибкой</h1>
          </div>
        ),
      },
      {
        path: '*',
        element: <GuestAuthIntercept />,
      },
    ],
  },
]
